export const GET_TICKET_STATUS = 'GET_TICKET_STATUS';
export const GET_TICKETS = 'GET_TICKETS';
